import { AbpMultiTenancyService } from "abp-ng2-module";
import { Injectable } from "@angular/core";
import { AppCookieService } from "./app-cookie.service";
import {
  ApplicationInfoDto,
  GeneralSettingDto,
  GetCurrentLoginInformationsOutput,
  SessionServiceProxy,
  TenantLoginInfoDto,
  UserLoginInfoDto,
} from "@shared/service-proxies/service-proxies";

@Injectable()
export class AppSessionService {
  private _user: UserLoginInfoDto;
  private _tenant: TenantLoginInfoDto;
  private _application: ApplicationInfoDto;
  private _generalSetting: GeneralSettingDto;

  constructor(
    private _sessionService: SessionServiceProxy,
    private _abpMultiTenancyService: AbpMultiTenancyService,
    private _cookieService: AppCookieService
  ) {}

  get application(): ApplicationInfoDto {
    return this._application;
  }

  get user(): UserLoginInfoDto {
    return this._user;
  }

  get userId(): number {
    return this.user ? this.user.id : null;
  }

  get tenant(): TenantLoginInfoDto {
    return this._tenant;
  }

  get tenantId(): number {
    return this.tenant ? this.tenant.id : null;
  }

  get companyName(): string {
    return this._generalSetting ? this._generalSetting.companyName : "";
  }

  get companyLogo(): string {
    return this._generalSetting ? this._generalSetting.imagePath : "";
  }

  getShownLoginName(): string {
    const userName = this._user.userName;
    if (!this._abpMultiTenancyService.isEnabled) {
      return userName;
    }

    return (this._tenant ? this._tenant.tenancyName : ".") + "\\" + userName;
  }

  init(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this._sessionService
        .getCurrentLoginInformations()
        .toPromise()
        .then(
          (result: GetCurrentLoginInformationsOutput) => {
            this._application = result.application;
            this._user = result.user;
            this._tenant = result.tenant;
            this._generalSetting = result.generalSetting;
            if (this._generalSetting?.companyName)
              this._cookieService.set(
                "company-name",
                this._generalSetting.companyName
              );
            else {
              this._cookieService.delete("company-name");
            }

            if (this._generalSetting?.imagePath)
              this._cookieService.set(
                "company-logo",
                this._generalSetting.imagePath
              );
            else {
              this._cookieService.delete("company-logo");
            }

            resolve(true);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  changeTenantIfNeeded(tenantId?: number): boolean {
    if (this.isCurrentTenant(tenantId)) {
      return false;
    }

    abp.multiTenancy.setTenantIdCookie(tenantId);
    location.reload();
    return true;
  }

  private isCurrentTenant(tenantId?: number) {
    if (!tenantId && this.tenant) {
      return false;
    } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
      return false;
    }

    return true;
  }
}
